import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { WorkflowAvatarValue } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateWorkflowAvatarProps = UpdateByIdProps<WorkflowAvatarValue>;

export type UseUpdateWorkflowAvatarReturn = {
  update: (props: UpdateWorkflowAvatarProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateWorkflowAvatar = (): UseUpdateWorkflowAvatarReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } =
    useUpdate<WorkflowAvatarValue>({
      operation: async (avatar, workflowId) => {
        if (avatar instanceof File) {
          await workflowService.updateAvatar(avatar, workflowId);
          return;
        }

        await workflowService.removeAvatar(workflowId);
      },
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateWorkflowAvatar;
